<div class="fs-4 text-dark fw-bold lh-base">
  {{ value }}
</div>

<div class="fs-7 text-gray-600 lh-base">
  {{ label }}
</div>
